/**
 * @type {Object} - list of registered command to execute
 */
export const pubSubApi = {
    'FANZONE_DATA': 'FANZONE_DATA',
    'FANZONE_TOGGLE_ON': 'FANZONE_TOGGLE_ON',
    'FANZONE_NO_THANKS': 'NO_THANKS',
    'FANZONE_COMING_BACK': 'FANZONE_COMING_BACK',
    'HIDE_FANZONE_GAMES_TAB': 'HIDE_FANZONE_GAMES_TAB',
    'BPP_TOKEN_SET': 'BPP_TOKEN_SET',
    'FZ_MENUS_UPDATE': 'FZ_MENUS_UPDATE',
    'QUICKBET_EXTRAPLACE_SELECTION': 'QUICKBET_EXTRAPLACE_SELECTION',
    'LUCKY_DIP_KEYPAD_PRESSED': 'LUCKY_DIP_KEYPAD_PRESSED',
    'LUCKY_DIP_SHOW_LOADER': 'LUCKY_DIP_SHOW_LOADER',
    'LUCKY_DIP_SHOW_NOMARKETS': 'LUCKY_DIP_SHOW_NOMARKETS',
    'LUCKY_DIP_OVERLAY_CLOSE': 'LUCKY_DIP_OVERLAY_CLOSE',
    'LUCKY_DIP_DEEPLINK_BET_RECEIPT_CLOSE': 'LUCKY_DIP_DEEPLINK_BET_RECEIPT_CLOSE',
    'FANZONE_SHOW_GAMES_TAB': 'FANZONE_SHOW_GAMES_TAB',
    'FANZONE_SHOW_GAMES_TOOLTIP': 'FANZONE_SHOW_GAMES_TOOLTIP',
    'BETSLIP_COUNTER_UPDATE': 'BETSLIP_COUNTER_UPDATE',
    'ADDTOBETSLIP_PROCESS_FINISHED': 'ADDTOBETSLIP_PROCESS_FINISHED',
    'DS_BETSLIP_COUNTER_UPDATE': 'DS_BETSLIP_COUNTER_UPDATE',
    'ACCA_NOTIFICATION_CHANGED': 'ACCA_NOTIFICATION_CHANGED',
    'ACCA_NOTIFICATION_ENABLE': 'ACCA_NOTIFICATION_ENABLE',
    'SET_BIR_COUNTDOWN_TIMER': 'SET_BIR_COUNTDOWN_TIMER',
    'CASHOUT_COUNTDOWN_TIMER': 'CASHOUT_COUNTDOWN_TIMER',
    'QUICKBET_COUNTDOWN_TIMER': 'QUICKBET_COUNTDOWN_TIMER',
    'SET_PLAYER_INFO': 'SET_PLAYER_INFO',
    'BETSLIP_SELECTIONS_UPDATE': 'BETSLIP_SELECTIONS_UPDATE',
    'ADD_TO_BETSLIP_BY_SELECTION': 'ADD_TO_BETSLIP_BY_SELECTION',
    'PUSH_TO_GTM': 'PUSH_TO_GTM',
    'SYSTEM_CONFIG_UPDATED': 'SYSTEM_CONFIG_UPDATED',
    'DIGIT_KEYBOARD_SHOWN': 'DIGIT_KEYBOARD_SHOWN',
    'DISPLAY_WIDGET': 'DISPLAY_WIDGET',
    'SHOW_WIDGET': 'SHOW_WIDGET',
    'ROUTE_CHANGE_STATUS': 'ROUTE_CHANGE_STATUS',
    'SORT_BY_OPTION': 'SORT_BY_OPTION',
    'CLOSE_SORT_BY': 'CLOSE_SORT_BY',
    'DIGIT_KEYBOARD_HIDDEN': 'DIGIT_KEYBOARD_HIDDEN',
    'BETBUILDER_UPDATED': 'BETBUILDER_UPDATED',
    'CLEAR_BETBUILDER': 'CLEAR_BETBUILDER',
    'CLEAR_BET_BUILDER': 'CLEAR_BET_BUILDER',
    'BYB_SHOWN': 'BYB_SHOWN',
    'TOTEPOOL_SHOWN': 'TOTEPOOL_SHOWN',
    'CHANGE_STATE_CHANGE_COMPETITIONS': 'CHANGE_STATE_CHANGE_COMPETITIONS',
    'CONFIRM_DEPOSIT': 'CONFIRM_DEPOSIT',
    'RELOCATE_BET_BUILDER': 'RELOCATE_BET_BUILDER',
    'DIGIT_KEYBOARD_KEY_PRESSED': 'DIGIT_KEYBOARD_KEY_PRESSED',
    'DIGIT_KEYBOARD_DEC_DOT_PRESSED': 'DIGIT_KEYBOARD_DEC_DOT_PRESSED',
    'RENDER_QUICKBET_COMPONENT': 'RENDER_QUICKBET_COMPONENT',
    'RENDER_QUACCA_BAR_COMPONENT': 'RENDER_QUACCA_BAR_COMPONENT',
    'ADD_TO_QUICKBET': 'ADD_TO_QUICKBET',
    'REMOVE_FROM_QUICKBET': 'REMOVE_FROM_QUICKBET',
    'REMOVE_FROM_SB_QUICKBET': 'REMOVE_FROM_SB_QUICKBET',
    'ADD_TO_QUICKBET_BMA_STREAM_BET': 'ADD_TO_QUICKBET_BMA_STREAM_BET',
    'CLOSE_QUICKBET_PARTIAL_OVERLAY': 'CLOSE_QUICKBET_PARTIAL_OVERLAY',
    'QUICKBET_PARTIAL_OVERLAY_SHOW': 'QUICKBET_PARTIAL_OVERLAY_SHOW',
    'IS_WEB_VIDEO_STICKED': 'IS_WEB_VIDEO_STICKED',
    'STREAM_BET_VIDEO_MODE': 'STREAM_BET_VIDEO_MODE',
    'QUICKBET_INFO_PANEL': 'QUICKBET_INFO_PANEL',
    'REUSE_QUICKBET_SELECTION': 'REUSE_QUICKBET_SELECTION',
    'ADD_TO_QUICKBET_FROM_NATIVE': 'ADD_TO_QUICKBET_FROM_NATIVE',
    'BETSLIP_LABEL': 'BETSLIP_LABEL',
    'REUSE_LOCATION': 'REUSE_LOCATION',
    'BETSLIP_BALANCE_DROPDOWN_HIDE': 'BETSLIP_BALANCE_DROPDOWN_HIDE',
    'COUNTER_UPDATE': 'COUNTER_UPDATE',
    'RELOAD_COMPONENTS': 'RELOAD_COMPONENTS',
    'REMOTE_BETSLIP_OVERASK_TRIGGERED': 'REMOTE_BETSLIP_OVERASK_TRIGGERED',
    'SHOW_FOOTBALL_TUTORIAL': 'SHOW_FOOTBALL_TUTORIAL',
    'QB_QUICKSTAKE_PRESSED': 'QB_QUICKSTAKE_PRESSED',
    'QB_QUICKSTAKE_PRESSED_DIGIT_KEYBOARD': 'QB_QUICKSTAKE_PRESSED_DIGIT_KEYBOARD',
    'ADD_TO_YC_BETSLIP': 'ADD_TO_YC_BETSLIP',
    'REMOTE_BS_RECONNECT': 'REMOTE_BS_RECONNECT',
    'VIEW_CHANGE': 'VIEW_CHANGE',
    'BETSLIP_LIVEUPDATE_SUBSCRIBE_FOR_TOTE_BETS': 'BETSLIP_LIVEUPDATE_SUBSCRIBE_FOR_TOTE_BETS',
    'REUSE_TOTEBET': 'REUSE_TOTEBET',
    'BETSLIP_LIVEUPDATE_UNSUBSCRIBE': 'BETSLIP_LIVEUPDATE_UNSUBSCRIBE',
    'IS_BANNER_SECTION_AVAILABLE': 'IS_BANNER_SECTION_AVAILABLE',
    'HIDE_OPTA_SCOREBOARD': 'HIDE_OPTA_SCOREBOARD',
    'UPDATE_CASHOUT_BET': 'UPDATE_CASHOUT_BET',
    'LIVE_STREAM_BIR': 'LIVE_STREAM_BIR',
    'STICKY_VIRTUAL_SCROLL': 'STICKY_VIRTUAL_SCROLL',
    'BETSLIP_CLEAR_STAKE': 'BETSLIP_CLEAR_STAKE',
    'LIVE_BET_UPDATE': 'LIVE_BET_UPDATE',
    'PAYOUT_UPDATE': 'PAYOUT_UPDATE',
    'CURRENT_FOOTBALL_ALERTS_STATE_CHANGED': 'CURRENT_FOOTBALL_ALERTS_STATE_CHANGED',
    'CASH_OUT_BET_PROCESSED': 'CASH_OUT_BET_PROCESSED',
    'EVENT_ADDED': 'EVENT_ADDED',
    'EVENT_REMOVED': 'EVENT_REMOVED',
    'FEATURED_CONNECT_STATUS': 'FEATURED_CONNECT_STATUS',
    'FOOTER_MENU_READY': 'FOOTER_MENU_READY',
    'USER_BALANCE_UPD': 'USER_BALANCE_UPD',
    'EXTRA_PLACE_RACE_OFF': 'EXTRA_PLACE_RACE_OFF',
    'IS_LIVE': 'IS_LIVE',
    'IS_RESULTED': 'IS_RESULTED',
    'MSG_UPDATE': 'MSG_UPDATE',
    'MENU_UPDATE': 'MENU_UPDATE',
    'SERVER_MESSAGE': 'SERVER_MESSAGE',
    'show-slide-out-betslip-false': 'show-slide-out-betslip-false',
    'show-slide-out-betslip': 'show-slide-out-betslip',
    'show-slide-out-betslip-true': 'show-slide-out-betslip-true',
    'show_betslip': 'show_betslip',
    'BETSLIP_UPDATED': 'BETSLIP_UPDATED',
    'EACHWAY_FLAG_UPDATED': 'EACHWAY_FLAG_UPDATED',
    'USER_INTERACTION_REQUIRED': 'USER_INTERACTION_REQUIRED', // - stop placing bet if notification popup is displayed after logged in
    'SYNC_BETSLIP_FROM_NATIVE': 'SYNC_BETSLIP_FROM_NATIVE',
    'BET_RECEIPT': 'BET_RECEIPT',
    'BET_EVENTENTITY_UPDATED': 'BET_EVENTENTITY_UPDATED',
    'REMOVE_VS_STORAGE': 'REMOVE_VS_STORAGE',
    'SPORT_CHANGED': 'SPORT_CHANGED',
    'PIN_TOP_BAR': 'PIN_TOP_BAR',
    'MEETING_OVERLAY_FLAG': 'MEETING_OVERLAY_FLAG',
    'BETSLIP_BET_DATA': 'BETSLIP_BET_DATA',
    'SET_RESTRICTED_RACECARD': 'SET_RESTRICTED_RACECARD',

    // PERFORMANCE MARK
    'PERFORMANCE_MARK': 'PERFORMANCE_MARK',

    // YOURCALL
    'YOURCALL_SELECTION_UPDATE': 'YOURCALL_SELECTION_UPDATE',
    'AFTER_PANEL_RENDER': 'AFTER_PANEL_RENDER',
    'UPDATE_QUICKBET_NOTIFICATION': 'UPDATE_QUICKBET_NOTIFICATION',
    'QUICKBET_SELECTION_UPDATE': 'QUICKBET_SELECTION_UPDATE',
    'QUICKBET_CARD_CHANGE': 'QUICKDEPOSIT_CARD_CHANGE',

    'TOGGLE_LOADING_OVERLAY': 'TOGGLE_LOADING_OVERLAY',
    'GET_QUICKBET_SELECTION_STATUS': 'GET_QUICKBET_SELECTION_STATUS',
    'QUICKBET_OPENED': 'QUICKBET_OPENED',
    'QUICKBET_PANEL_CLOSE': 'QUICKBET_PANEL_CLOSE',
    'PAYMENT_ACCOUNTS_PASSED': 'PAYMENT_ACCOUNTS_PASSED',
    'SEO_DATA_UPDATED': 'SEO_DATA_UPDATED',
    'AUTOSEO_DATA_UPDATED': 'AUTOSEO_DATA_UPDATED',
    'AUTO_SEOTAGS_DATA_UPDATED': 'AUTO_SEOTAGS_DATA_UPDATED',
    'SCHEMA_DATA_UPDATED': 'SCHEMA_DATA_UPDATED',
    'SCHEMA_DATA_REMOVED': 'SCHEMA_DATA_REMOVED',
    'NEXT_RACES_DATA': 'NEXT_RACES_DATA',
    'YC_DASHBOARD_DISPLAYING_CHANGED': 'YC_DASHBOARD_DISPLAYING_CHANGED',
    'YC_MARKET_TOGGLED': 'YC_MARKET_TOGGLED',
    'YC_NOTIFICATION_TODDLED': 'YC_NOTIFICATION_TODDLED',
    'UK_TOTE_LEG_UPDATED': 'UK_TOTE_LEG_UPDATED',
    'BET_PLACED': 'BET_PLACED', // on success bet placed on betslip and quickbet
    'MY_BET_PLACED': 'MY_BET_PLACED', // on success bet placed on betslip and quickbet
    'MY_BET_PLACED_LD': 'MY_BET_PLACED_LD', // on success bet placed on luckydip quickbet
    'TOTE_BET_PLACED': 'TOTE_BET_PLACED', // - fired on successful(*) tote bet placement response to reload stream services
    // (* - doesn't mean that bet was accepted)
    'SUBSCRIBE_LS': 'SUBSCRIBE_LS',
    'UNSUBSCRIBE_LS': 'UNSUBSCRIBE_LS',
    'SUBSCRIBE_OB_LS': 'SUBSCRIBE_OB_LS',
    'UNSUBSCRIBE_OB_LS': 'UNSUBSCRIBE_OB_LS',
    'OB_LS_WS_DISCONNECT': 'OB_LS_WS_DISCONNECT',
    'UNSUBSCRIBE_LS_UPDATES_MS': 'UNSUBSCRIBE_LS_UPDATES_MS',
    'REMOVE_ENTITY': 'REMOVE_ENTITY',
    'OUTCOME_UPDATED': 'OUTCOME_UPDATED',
    'LOGIN_POPUPS_START': 'LOGIN_POPUPS_START',
    'LOGIN_POPUPS_END': 'LOGIN_POPUPS_END',
    'EVENT_COUNT': 'EVENT_COUNT', // Count events length
    'WS_EVENT_UPDATE': 'WS_EVENT_UPDATE', // Event Update using Web Socket connection
    'WS_EVENT_UPDATED': 'WS_EVENT_UPDATED',
    'WS_EVENT_DELETE': 'WS_EVENT_DELETE', // Event Delete from CACHE
    'WS_EVENT_LIVE_UPDATE': 'WS_EVENT_LIVE_UPDATE', // Live Event Update using Web Socket connection
    'WIDGET_VISIBILITY': 'WIDGET_VISIBILITY', // Set widget visibility
    'SCOREBOARD_VISIBILITY': 'SCOREBOARD_VISIBILITY', // Set Scoreboard visibility
    'SCOREBOARD_VISUALIZATION_LOADED': 'SCOREBOARD_VISUALIZATION_LOADED',
    'DELETE_SELECTION_FROM_CACHE': 'DELETE_SELECTION_FROM_CACHE', // Delete selection on Live Update
    'OPT_IN_SPLASH_UPDATE_STATE': 'OPT_IN_SPLASH_UPDATE_STATE',
    'TABSPANEL_SCROLL_TO_SELECTED': 'TABSPANEL_SCROLL_TO_SELECTED',
    'MOVE_EVENT_TO_INPLAY': 'MOVE_EVENT_TO_INPLAY', // Move event from upcoming module to inplay module(bigcompetitions-> Next Events module)
    'SUSPENDED_EVENT': 'SUSPENDED_EVENT', // Apply update to event(suspend), when live update received +
    // + from LS MS(bigcompetitions -> competition outrights module)
    'COOKIE_BANNER_CLOSED': 'COOKIE_BANNER_CLOSED',
    'SUSPEND_IHR_EVENT_OR_MRKT': 'SUSPEND_IHR_EVENT_OR_MRKT',
    'NATIVE_COOKIE_BANNER_CLOSED': 'NATIVE_COOKIE_BANNER_CLOSED',
    'CLOSE_LOGIN_DIALOG': 'CLOSE_LOGIN_DIALOG',
    'SESSION_LOGIN': 'SESSION_LOGIN',
    'SUCCESSFUL_LOGIN': 'SUCCESSFUL_LOGIN',
    'FAILED_LOGIN': 'FAILED_LOGIN',
    'PRIVATE_MARKETS_TAB': 'PRIVATE_MARKETS_TAB',
    'HIDE_PRIVATE_MARKETS_TAB': 'HIDE_PRIVATE_MARKETS_TAB',
    'SESSION_LOGOUT': 'SESSION_LOGOUT',
    'LIVE_SERVE_MS_UPDATE': 'LIVE_SERVE_MS_UPDATE',
    'LIVE_SERVE_UPDATE': 'LIVE_SERVE_UPDATE',
    'OPEN_LOGIN_DIALOG': 'OPEN_LOGIN_DIALOG', // Open Login Dialog
    'LOGIN_DIALOG_CLOSED': 'LOGIN_DIALOG_CLOSED',
    'LOGIN_BUTTON_CLICKED': 'LOGIN_BUTTON_CLICKED',
    'SHOW_HIDE_WIDGETS': 'SHOW_HIDE_WIDGETS',
    'SPORT_DEFAULT_PAGE': 'SPORT_DEFAULT_PAGE',
    'BET_FILTER_PARAMS': 'BET_FILTER_PARAMS',
    'TOGGLE_MOBILE_HEADER_FOOTER': 'TOGGLE_MOBILE_HEADER_FOOTER', // Hide mobile Footer and Header
    'QUICK_SWITCHER_ACTIVE': 'QUICK_SWITCHER_ACTIVE',
    'HOME_BETSLIP': 'HOME_BETSLIP',
    'CHECK_RETAIL_NATIVE': 'CHECK_RETAIL_NATIVE',
    'UPGRADE_STATUS_CHANGED': 'UPGRADE_STATUS_CHANGED',
    'UPGRADE_FROM_BETSLIP': 'UPGRADE_FROM_BETSLIP',
    'APP_BUILD_VERSION': 'APP_BUILD_VERSION',
    'ROULETTE_JOURNEY_END': 'ROULETTE_JOURNEY_END',
    'FREEBETS_UPDATED': 'FREEBETS_UPDATED',
    'FREEBETS_BY_SELECTION': 'FREEBETS_BY_SELECTION',
    'FREEBET_SELECTED_EVENT': 'FREEBET_SELECTED_EVENT',
    'STORE_FREEBETS_ON_REFRESH': 'STORE_FREEBETS_ON_REFRESH',
    'GAMING_OVERLAY_OPEN': 'GAMING_OVERLAY_OPEN', // Open Gaming Overlay
    'GAMING_OVERLAY_CLOSE': 'GAMING_OVERLAY_CLOSE', // Close Gaming Overlay
    'VIDEO_STREAM_ERROR_DIALOG_CLOSED': 'VIDEO_STREAM_ERROR_DIALOG_CLOSED',
    'UPDATE_BYB_BET': 'UPDATE_BYB_BET',
    'UPDATE_MATCHCOMMENTARY_DATA': 'UPDATE_MATCHCOMMENTARY_DATA',
    'BET_LEGS_LOADED': 'BET_LEGS_LOADED',
    'BET_TRACKER_TOOLTIP': 'BET_TRACKER_TOOLTIP',
    'CLOSE_TOOLTIPS': 'CLOSE_TOOLTIPS',

    //SELECTION CHECK FOR FANZONE
    'GET_USER_PREFRENCE': 'GET_USER_PREFRENCE',
    'VALIDATE_SELECTION': 'VALIDATE_SELECTION',
    'INVALID_FANPRICE_SELECTIONS': 'INVALID_FANPRICE_SELECTIONS',
    'VALIDATE_FANPRICE_SELECTIONS': 'VALIDATE_FANPRICE_SELECTIONS',
    'IS_VALID_FANPRICE': 'IS_VALID_FANPRICE',
    'VALIDATE_ADD_SELECTIONS': 'VALIDATE_ADD_SELECTIONS',

    /**
     * Direct Chat
     */
    'DC_CHAT_ACTIVATE': 'DC_CHAT_ACTIVATE',
    'DC_TOPIC_SELECTED': 'DC_TOPIC_SELECTED',
    'DC_CHAT_LEAVE': 'DC_CHAT_LEAVE',
    'REINIT_DC_SESSION': 'REINIT_DC_SESSION',
    /**
     * ===========
     */
    'TOTE_BETSLIP_UPDATED': 'TOTE_BETSLIP_UPDATED',
    'FIXED_CONTENT_REDRAW': 'FIXED_CONTENT_REDRAW',
    'IOS_CLOSE_NG_DIALOG': 'IOS_CLOSE_NG_DIALOG',

    'LOGIN_COUNTER_UPDATE': 'LOGIN_COUNTER_UPDATE',

    'APP_IS_LOADED': 'APP_IS_LOADED', // Event to notify about all pending requests finished after app's first start

    // INPLAY
    'EVENT_COUNT_UPDATE': 'EVENT_COUNT_UPDATE',
    'RELOAD_IN_PLAY': 'RELOAD_IN_PLAY',
    'INPLAY_LS_COMPETITION_ADDED': 'INPLAY_LS_COMPETITION_ADDED',
    'INPLAY_LS_COMPETITION_REMOVED': 'INPLAY_LS_COMPETITION_REMOVED',
    'INPLAY_COMPETITION_REMOVED': 'INPLAY_COMPETITION_REMOVED',
    'VIRTUAL_EVENT_COUNT_UPDATE': 'GET_VIRTUAL_SPORTS_RIBBON',

    //INSIGHTS
    'RELOAD_INSIGHTS': 'RELOAD_INSIGHTS',
    'INSIGHTS_SUBSCRIPTION': 'INSIGHTS_SUBSCRIPTION',

    // LIVE UPDATES
    'EVENT_SCORES_UPDATE': 'EVENT_SCORES_UPDATE',
    'DELETE_SELECTION_FROMCACHE': 'DELETE_SELECTION_FROMCACHE',
    'EVENTS_CLOCK_UPDATE': 'EVENTS_CLOCK_UPDATE',
    'LIVE_MARKET_FOR_EDP': 'LIVE_MARKET_FOR_EDP',
    'RELOAD_LIVE_STREAM_WIDGET': 'RELOAD_LIVE_STREAM_WIDGET',
    'SET_LIVE_STREAM_WIDGETS_TAB': 'SET_LIVE_STREAM_WIDGETS_TAB',
    'DELETE_EVENT_ON_LIVE_STREAM_MODULE': 'DELETE_EVENT_ON_LIVE_STREAM_MODULE',

    // ODDS BOOST
    'ODDS_BOOST_CHANGE': 'ODDS_BOOST_CHANGE',
    'ODDS_BOOST_REBOOST': 'ODDS_BOOST_REBOOST',
    'ODDS_BOOST_REBOOST_CLICK': 'ODDS_BOOST_REBOOST_CLICK',
    'ODDS_BOOST_UNSET_FREEBETS': 'ODDS_BOOST_UNSET_FREEBETS',
    'ODDS_BOOST_HANDLE_SP': 'ODDS_BOOST_HANDLE_SP',
    'ODDS_BOOST_INFO_DIALOG': 'ODDS_BOOST_INFO_DIALOG',
    'ODDS_BOOST_SEND_GTM': 'ODDS_BOOST_SEND_GTM',
    'ODDS_BOOST_CHECK_BS_SELECTIONS': 'ODDS_BOOST_CHECK_BS_SELECTIONS',
    'STORE_ODDS_BOOST': 'STORE_ODDS_BOOST',
    'ODDS_BOOST_DECREMENT_COUNTER': 'ODDS_BOOST_DECREMENT_COUNTER',
    'ODDS_BOOST_TOKENS_UPDATE': 'ODDS_BOOST_TOKENS_UPDATE',

    // FOR BETS COUNTER
    'BETS_COUNTER_PLACEBET': 'BETS_COUNTER_PLACEBET',
    'BETS_COUNTER_CASHOUT_BET': 'BETS_COUNTER_CASHOUT_BET',
    'BETS_COUNTER_OPEN_BETS': 'BETS_COUNTER_OPEN_BETS',
    'EVENT_MY_BETS_COUNTER': 'EVENT_MY_BETS_COUNTER',

    // EDIT MY ACCA
    'EMA_CONFIRM_NEEDED': 'EMA_CONFIRM_NEEDED',
    'EMA_HANDLE_BET_LIVE_UPDATE': 'EMA_HANDLE_BET_LIVE_UPDATE',
    'UPDATE_EMA_ODDS': 'UPDATE_EMA_ODDS',
    'EMA_UNSAVED_IN_WIDGET': 'EMA_UNSAVED_IN_WIDGET',
    'EMA_UNSAVED_ON_EDP': 'EMA_UNSAVED_ON_EDP',
    'EMA_OPEN_CANCEL_DIALOG': 'EMA_OPEN_CANCEL_DIALOG',
    'EDIT_MY_ACCA': 'EDIT_MY_ACCA',

    // NOTIFICATIONS
    'NOTIFICATION_SHOW': 'NOTIFICATION_SHOW',
    'NOTIFICATION_HIDE': 'NOTIFICATION_HIDE',

    // ROUTER
    'REDIRECT_TO_URL': 'REDIRECT_TO_URL',

    // INSHOP BETS COUNT FOR MY BETS
    'SETTLED_INSHOP_BETS_COUNT': 'SETTLED_INSHOP_BETS_COUNT',
    'OPEN_INSHOP_BETS_COUNT': 'OPEN_INSHOP_BETS_COUNT',

    // NATIVE
    'VIRTUAL_ORIENTATION_CHANGED': 'VIRTUAL_ORIENTATION_CHANGED',
    'ORIENTATION_CHANGED': 'ORIENTATION_CHANGED',
    'SYNC_BETSLIP_TO_NATIVE': 'SYNC_BETSLIP_TO_NATIVE',
    'SYNC_FAVOURITES_TO_NATIVE': 'SYNC_FAVOURITES_TO_NATIVE',

    // Dialog
    'NEW_DIALOG_OPENED': 'NEW_DIALOG_OPENED',

    // Gambling control
    'CLOSURE_CHECKED': 'CLOSURE_CHECKED', // TODO: Should be removed after Vanilla integration

    // FEATURED MODULE
    'NAMESPACE_ERROR': 'NAMESPACE_ERROR',
    'FEATURED_STRUCTURE_CHANGED': 'FEATURED_STRUCTURE_CHANGED',

    // MODULES LAZY LOADING
    'DEFERRED_MODULES_LOADED': 'DEFERRED_MODULES_LOADED',
    'BETSLIP_LOADED': 'BETSLIP_LOADED',
    'QUICKBET_LOADED': 'QUICKBET_LOADED',
    'EVENT_VIDEO_STREAM_LOADED': 'EVENT_VIDEO_STREAM_LOADED',

    // BETSLIP SLIDE IN/OUT
    'BETSLIP_SIDE_BAR_MOTION': 'BETSLIP_SIDE_BAR_MOTION',

    // TODO (BMA-40873): must be removed after refactoring services for live updates
    'CASHOUT_LIVE_SCORE_UPDATE': 'CASHOUT_LIVE_SCORE_UPDATE',
    'CASHOUT_LIVE_SCORE_EVENT_UPDATE': 'CASHOUT_LIVE_SCORE_EVENT_UPDATE',
    'CASHOUT_CTRL_STATUS': 'CASHOUT_CTRL_STATUS',

    'CASH_OUT_MAP_UPDATED': 'CASH_OUT_MAP_UPDATED',

    // OVERASK
    'OVERASK_CLEAN_BETSLIP': 'OVERASK_CLEAN_BETSLIP',
    'OVERASK_STATE_RESTORED': 'OVERASK_STATE_RESTORED',
    'OVERASK_STATE_RESTORE_FAILED': 'OVERASK_STATE_RESTORE_FAILED',
    'OVERASK_REVIEW_STARTED': 'OVERASK_REVIEW_STARTED',
    'OVERASK_BETS_DATA_UPDATED': 'OVERASK_BETS_DATA_UPDATED',

    // MY_BETS
    'MY_BETS_UPDATED': 'MY_BETS_UPDATED',
    'EVENT_STARTED': 'EVENT_STARTED',
    'EVENT_FINSHED': 'EVENT_FINSHED',
    'TWO_UP_UPDATE': 'TWO_UP_UPDATE',

    'CHANGE_MARKET': 'CHANGE_MARKET',
    'CHANGE_BET_FILTER': 'CHANGE_BET_FILTER',

    'BS_SELECTION_LIVE_UPDATE': 'BS_SELECTION_LIVE_UPDATE',
    'BLOCK_QUICK_BET': 'BLOCK_QUICK_BET',
    'BS_HIDE_FREEBET_TOOLTIP': 'BS_HIDE_FREEBET_TOOLTIP',
    'SELECTION_ADDED': 'SELECTION_ADDED',
    'SET_FREE_BET': 'SET_FREE_BET',

    'BS_SHOW_OVERLAY': 'BS_SHOW_OVERLAY',
    'BS_SHOW_SUSP_OVERLAY': 'BS_SHOW_SUSP_OVERLAY',
    'BS_BET_NOT_ALLOWED': 'BS_BET_NOT_ALLOWED',

    'TOGGLE_QUICK_DEPOSIT_IFRAME': 'TOGGLE_QUICK_DEPOSIT_IFRAME',
    'TAB_RESET_MARKET_SWITCHER': 'TAB_RESET_MARKET_SWITCHER',

    'SHOW_QUICK_DEPOSIT_SUCCESS_POPUP': 'SHOW_QUICK_DEPOSIT_SUCCESS_POPUP',

    'SHOW_LOCATION_RESTRICTED_BETS_DIALOG': 'SHOW_LOCATION_RESTRICTED_BETS_DIALOG',

    'SPORT_EDP_CLOSED': 'SPORT_EDP_CLOSED',
    // Question engine
    'QE_FATAL_ERROR': 'QE_FATAL_ERROR',
    'QE_HISTORY_DATA_RECEIVED': 'QE_HISTORY_DATA_RECEIVED',

    // Timeline
    'TIMELINE_SHOWN': 'TIMELINE_SHOWN',
    'GET_TIMELINE_SHOWN': 'GET_TIMELINE_SHOWN',
    'TIMELINE_SETTINGS_CHANGE': 'TIMELINE_SETTINGS_CHANGE',
    'SHOW_TIMELINE_TUTORIAL': 'SHOW_TIMELINE_TUTORIAL',

    'IMPLICIT_BALANCE_REFRESH': 'IMPLICIT_BALANCE_REFRESH',
    'FLUSH_VS_STORAGE': 'FLUSH_VS_STORAGE',
    'VS_EVENT_FINISHED': 'VS_EVENT_FINISHED',

    'REDIRECT': 'REDIRECT',
    'LAST_MADE_BET': 'LAST_MADE_BET',
    'STORE_FREEBETS': 'STORE_FREEBETS',
    'STORE_PRIVATE_MARKETS': 'STORE_PRIVATE_MARKETS',
    'SET_INPLAY_WIDGETS_TAB': 'SET_INPLAY_WIDGETS_TAB',
    'INPLAY_DATA_RELOADED': 'INPLAY_DATA_RELOADED',
    'LOGIN_ONGOING': 'LOGIN_ONGOING',
    'LOGIN_PENDING': 'LOGIN_PENDING',
    'REUSE_OUTCOME': 'REUSE_OUTCOME',
    'EXECUTE_OVERASK': 'EXECUTE_OVERASK',
    'REFRESH_BETSLIP': 'REFRESH_BETSLIP',
    'REMOVE_BYB_STORED_EVENT': 'REMOVE_BYB_STORED_EVENT',
    'REMOVE_EDP_BYB_TABS': 'REMOVE_EDP_BYB_TABS',

    'VANILLA_SCOPE_CHANGE': 'VANILLA_SCOPE_CHANGE', // triggered when vanilla routes with portal loaded / unloaded, passed true/false

    // user settings
    'SET_ODDS_FORMAT': 'SET_ODDS_FORMAT',
    'USER_BALANCE_SHOW': 'USER_BALANCE_SHOW',

    // Auth
    'SET_LOGOUT_STATUS': 'SET_LOGOUT_STATUS', // сlose bpp connection, interrupt session timer, enable optInBtn

    'RELOAD_CASHOUT': 'RELOAD_CASHOUT',
    'LOAD_CASHOUT_BETS': 'LOAD_CASHOUT_BETS',

    // device
    'DEVICE_VIEW_TYPE_CHANGED_NEW': 'DEVICE_VIEW_TYPE_CHANGED_NEW',

    // market
    'DELETE_MARKET_FROM_CACHE': 'DELETE_MARKET_FROM_CACHE',
    'DELETE_EVENT_FROM_CACHE': 'DELETE_EVENT_FROM_CACHE',
    'IS_NATIVE_VIDEO_STICKED': 'IS_NATIVE_VIDEO_STICKED',

    // maintenance
    'MAINTENANCE_PAGE_DATA_CHANGED': 'MAINTENANCE_PAGE_DATA_CHANGED',
    'EVENT_BY_SPORTS_CHANNEL': 'EVENT_BY_SPORTS_CHANNEL',

    // racingposttip info
    'RACING_POST_TIP': 'RACING_POST_TIP',
    'IS_TIP_PRESENT': 'IS_TIP_PRESENT',
    'RP_TIP_GTM': 'RP_TIP_GTM',
    'HAS_MARKET_DESCRIPTION': 'HAS_MARKET_DESCRIPTION',

    // AWS Firehose
    'INIT_AWS': 'INIT_AWS',

    // FreeRide Bet
    'FREE_RIDE_BET': 'FreeRideBet',

    // SEGMENTED
    'SEGMENTED_INITIAL_DATA_RECEIVED': 'SEGMENTED_INITIAL_DATA_RECEIVED',
    'SEGMENT_RECEIVED': 'SEGMENT_RECEIVED',
    'SEGMENTED_INIT_FE_REFRESH': 'SEGMENTED_INIT_FE_REFRESH',
    'SEGMENT_API_FAILED': 'SEGMENT_API_FAILED',
    'CMS_SEGMENT_API_FAILED': 'CMS_SEGMENT_API_FAILED',

    // FIRST-BET PLACEMENT TUTORIAL
    'FIRST_BET_PLACEMENT_TUTORIAL': 'FIRST_BET_PLACEMENT_TUTORIAL',
    'FIRST_BET': 'FIRST_BET',
    //User account closure status

    'USER_CLOSURE_PLAY_BREAK': 'USER_CLOSURE_PLAY_BREAK',
    'BETPACK_PLACED': 'BETPACK_PLACED',

    //Two up Tracking
    'TWO_UP_TRACKING': 'TWO_UP_TRACKING',

    'PARTIAL_CASHOUT_SUCCESS': 'PARTIAL_CASHOUT_SUCCESS',
    // RGY
    'INITIATE_RGY_CALL': 'INITIATE_RGY_CALL',
    'RGY_DATA_LOADED': 'RGY_DATA_LOADED',
    //Bet Sharing
    'BET_SHARING_COMPLETED': 'BET_SHARING_COMPLETED',
    'ALL_IMAGES_LOADED': 'ALL_IMAGES_LOADED',

    //Future Tab
    'ACTIVE_FUTURE_TAB': 'ACTIVE_FUTURE_TAB',

    //Nextraces loaded on HR/GH homepage
    'RACING_NEXT_RACES_LOADED': 'RACING_NEXT_RACES_LOADED',
    'BETSLIP_BAR_UPDATE': 'BETSLIP_BAR_UPDATE',

    // Launch darkly flag
    'FLAG_TRACK_ADD': 'FLAG_TRACK_ADD',
    'FLAG_TRACK_ADD_DATA': 'FLAG_TRACK_ADD_DATA',
    'FLAG_LD_INIT': 'FLAG_LD_INIT',
    'FLAG_IDENTIFY_INIT': 'FLAG_IDENTIFY_INIT',

    'BSREVAMP_TOTEBETDATA': 'BSREVAMP_TOTEBETDATA',

    //Remove all from betslip
    'REMOVE_ALL_BETSLIP': 'REMOVE_ALL_BETSLIP',

    //Popular bets in sport page
    'INSIGHTS_MAIN_LOADING': 'INSIGHTS_MAIN_LOADING',

    //Reload inplay Accordions
    'RELOAD_INPLAY_ACC': 'RELOAD_INPLAY_ACC',
    //Reload inplay count
    'RESTORE_INPLAY_STRUCTURE': 'RESTORE_INPLAY_STRUCTURE',
    'IS_RACE_OFF_SPECIALS': 'IS_RACE_OFF_SPECIALS',

    'INSIGHTS_FLAG_UPDATE': 'INSIGHTS_FLAG_UPDATE',
    'NEXT_RACES_BIR_LD_UPDATED': 'NEXT_RACES_BIR_LD_UPDATED',
    'ACCA_UPSELL_MSG': 'ACCA_UPSELL_MSG',
    'ADD_TO_BETSLIP_BY_BYB_TAB_SELECTION': 'ADD_TO_BETSLIP_BY_BYB_TAB_SELECTION',
    'BYB_ACCA_ERRORS': 'BYB_ACCA_ERRORS',
    'BYB_EVENT_STARTED': 'BYB_EVENT_STARTED',
    'ADD_PARTIALOVERLAY_TOBETSLIP_IF_LUCKYDIP': 'ADD_PARTIALOVERLAY_TOBETSLIP_IF_LUCKYDIP',
    'BYB_ODDS': 'BYB_ODDS',
    'ACCA_INS': 'ACCA_INS',
    'ADD_NEW_QB_SELECTION': 'ADD_NEW_QB_SELECTION',
    'DATEPICKER_INVALID_RANGE': 'DATEPICKER_INVALID_RANGE',
    'REFRESH_POPULAR_ACCAS': 'REFRESH_POPULAR_ACCAS',
    'CLOSE_BETSLIP': 'CLOSE_BETSLIP',

    //QuaccaBar
    'ODDS_BOOST_QUACCABAR_UPDATED': 'ODDS_BOOST_QUACCABAR_UPDATED',
    'REMOVE_CLICKED': 'REMOVE_CLICKED',
    'TOGGLE_SRM_BET': 'TOGGLE_SRM_BET',
    'SRM_REMOVE_SELECTION': 'SRM_REMOVE_SELECTION',
    'SRM_REMOVE_TAB': 'SRM_REMOVE_TAB',
    'CLS_INIT_SPORT_DATA': 'CLS_INIT_SPORT_DATA',

    //PreCreated
    'UPDATE_TO_PRECREATED': 'UPDATE_TO_PRECREATED',
    'SYNC_PRECREATED_DATA': 'SYNC_PRECREATED_DATA',
};
